import { DemandSensingPage } from 'pages/demandsensing';

export const DemandSensing = () => {
  return (
    <>
      <DemandSensingPage />
    </>
  );
};
